import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { Corporate } from 'src/app/parametrage/core/model/corporate';
import { CorporateService } from 'src/app/corporate/core/service/corporate.service';
import { UrlTrackingService } from 'src/app/core/services/utils/url-tracking-service';

@Component({
  selector: "app-dossier-info",
  templateUrl: "./dossier-info.component.html",
  styleUrls: ["./dossier-info.component.scss"],
})
export class DossierInfoComponent implements OnInit {
  requestId: string;
  dossier: Request;
  WorkflowCategory: string = "PROFESSIONNEL";

  corporate : Corporate;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _requestService: RequestService,
    private _corporateService: CorporateService,
    private _urlTrackingService: UrlTrackingService
  ) {
    
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.requestId = params["requestId"];
      this.getRequestById(this.requestId);
      this.getCorporateByRequestId(this.requestId);
    });
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        if (
          data &&
          data.workflow &&
          data.workflow.categorie == this.WorkflowCategory
        ) {
          this.dossier = data;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  getCorporateByRequestId(requestId)
  {
    this._corporateService.getCorporateByRequestId(requestId)
    .subscribe(
        data => {
          this.corporate =  data;
        },
        error => {
          console.log(error);
        });
  }

  precedent(){
    const previousURL = this._urlTrackingService.getPreviousUrl();
    this._router.navigate([previousURL]);
  }

}
